import { apiGet, apiPost, apiPut } from '@jumbo/utils/ApiHelper';
import config from 'config';
const workbookApiUrl = config.loadApiUrl;

export function getBookingsApi(data) {
  return apiGet(workbookApiUrl, 'admin/loads/dispatches', data);
}

export function getAssignedOOApi() {
  return apiGet(workbookApiUrl, 'admin/loads/users');
}

export function getRequestsApi(data) {
  return apiGet(workbookApiUrl, 'admin/loads/requests/lists', data);
}

export function editRequestsApi(id, data) {
  return apiPut(workbookApiUrl, `admin/loads/requests/${id}`, data);
}
